import * as types from '../../constants/log/specialBoxLogConstants';

export const specialBoxLogListRequest = (
  {
    page,
    pageLength,
    beginDate,
    endDate,
    account,
    specialBoxNo,
    playedGameSessionNo,
    openTransactionNo,
    callback,
    error
  }
) => ({
  type: types.SPECIALBOXLOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  specialBoxNo,
  playedGameSessionNo,
  openTransactionNo,
  callback,
  error
});

export const specialBoxLogList = (list) => ({
  type: types.SPECIALBOXLOG_LIST,
  list,
});

export const setTotalCount = (totalCount) => ({
  type: types.SET_TOTAL_COUNT,
  totalCount,
});

export const setSpecialBoxLogPagination = (
  page, totalCount, beginDate, endDate, searchCode, searchString
) => ({
  type: types.SET_SPECIALBOXLOG_PAGINATION,
  page,
  totalCount,
  beginDate,
  endDate,
  searchCode,
  searchString,
});
